import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
    selector: '[logo]'
})
export class Logo {
    @Input()
    public logoSize = 300;

    @Input()
    public monochrome = false;

    @HostBinding('style.background-repeat')
    backgroundRepeat = 'no-repeat';

    @HostBinding('style.background-position-x')
    backgroundPositionX = 'center';

    @HostBinding('style.background-position-y')
    backgroundPositionY = 'top';

    @HostBinding('style.background-image')
    get backgroundImage() {
        return this.monochrome ? ' url(../../assets/logo_mono.png)' : 'url(../../assets/logo.png)';
    }

    @HostBinding('style.background-size')
    get backgroundSize() {
        return this.logoSize + 'px ' + this.logoSize + 'px !important';
    }

    @HostBinding('style.padding-top')
    get paddingTop() {
        return (this.logoSize * 0.75) + 'px !important';
    }
}
